import React, { useCallback } from 'react';
import { Box, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useDropzone } from 'react-dropzone';
import SchoolIcon from '@mui/icons-material/School';

export default function MyDropzone({ setPreviewFile, setSelectedFile, previewFile, selectedFile, isVideo, isLoading }) {
  const onDrop = useCallback((acceptedFiles) => {
    const imageFile = acceptedFiles[0];

    if (imageFile instanceof File) {
      setSelectedFile(imageFile);
      setPreviewFile(URL.createObjectURL(imageFile));
    }

  }, [setPreviewFile, setSelectedFile]);

  const { getRootProps, getInputProps } = useDropzone({
    accept: !isVideo
      ? {
        'image/jpeg': ['.jpeg'],
        'image/png': ['.png'],
        'image/webp': ['.webp'],
        'image/jpg': ['.jpg'],
        'image/gif': ['.gif'],
        'image/svg': ['.svg'],
      }
      : { 'video/mp4': ['.mp4'], 'video/mov': ['.mov'], 'video/avi': ['.avi'], 'video/webm': ['.webm'] },
    onDrop,
    minSize: 0,
    multiple: false,
  });

  return (
    <div style={{ width: 'fit-content', margin: !isVideo && '0 auto 39px auto' }}>
      <input {...getInputProps()} />

      {!isVideo ? (
        <Box
          {...getRootProps()}
          sx={{
            width: '242px',
            height: '242px',
            bgcolor: 'rgba(0, 0, 0, 0.41)',
            borderRadius: '50%',
            textAlign: 'center',
            display: 'grid',
            alignItems: 'center',
            mt: '30px',
            mx: 'auto',
            backgroundImage: previewFile && `url(${previewFile})`,
            backgroundSize: previewFile ? 'cover' : '242px 242px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            border: previewFile ? '1px solid #ccc' : 'none',
            cursor: 'pointer',
          }}
        >
          {!previewFile && (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#FFF',
              }}
            >
              <Box
                sx={{
                  width: 72,
                  height: 72,
                  borderRadius: '50%',
                  bgcolor: 'rgba(255,255,255,0.12)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  mb: 1.5,
                }}
              >
                <SchoolIcon sx={{ fontSize: 32 }} />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 500,
                  fontFamily: "'Noto Sans JP'",
                  letterSpacing: '0.15px',
                }}
              >
                Add Partnership Site Image
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  mt: 0.5,
                  opacity: 0.8,
                  maxWidth: 180,
                }}
              >
                Click to upload an image that represents this partnership site
              </Typography>
            </Box>
          )}
        </Box>
      ) : (
        <LoadingButton loading={isLoading} color="main" variant="video" {...getRootProps()}>
          <Box component="img" src="/assets/dashboard/videoUploadArrow.svg" sx={{ mx: 'auto', mb: '10px' }} />
          Add Video
        </LoadingButton>
      )}

      {!isVideo && selectedFile && selectedFile.size > 10 * 1024 * 1024 && (
        <Typography
          variant="body2"
          sx={{ fontWeight: 300, fontSize: '11px', lineHeight: '20px', textAlign: 'center', mt: '20px', color: 'error.main' }}
        >
          Make sure the Image is not larger than 10MB
        </Typography>
      )}
    </div>
  );
}
